"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html } from "@custom/schema";
import clsx from "clsx";
import React, { useState } from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function SoftwareGraphic(props) {
    var _useState = _sliced_to_array(useState(null), 2), hoveredBlock = _useState[0], setHoveredBlock = _useState[1];
    var handleMouseEnter = function(blockNumber) {
        setHoveredBlock(blockNumber);
    };
    var handleMouseLeave = function() {
        setHoveredBlock(null);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 pt-10 md:pt-0 pb-2 md:pb-28 font-heading"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-[688px] xl:max-w-[unset]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-x-3 md:gap-x-7 mb-14 md:mb-[90px]"
    }, /*#__PURE__*/ React.createElement("a", {
        href: props.block[0].target,
        className: "flex flex-1 items-center flex-col-reverse xl:flex-row-reverse relative transition-opacity duration-300 group",
        onMouseEnter: function() {
            return handleMouseEnter(1);
        },
        onMouseLeave: handleMouseLeave
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("border bg-yellow-100 border-gray-300 flex-1 max-w-[330px] w-full", {
            "opacity-20": hoveredBlock === 2 || hoveredBlock === 3
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center font-semibold font-heading bg-white py-5 md:py-5 text-xs md:text-lg lg:text-xl"
    }, props.block[0].title), /*#__PURE__*/ React.createElement("div", {
        className: "p-8 md:px-4 md:py-7 border-t border-t-gray-300 text-center"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/Group1.svg",
        alt: "Community Hub graphic",
        className: "mx-auto"
    }))), /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/Bracket.svg",
        alt: "Left bracket",
        className: "knime-hidden md:block xl:hidden mt-4 mb-7"
    }), /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/left-bracket-graphic.svg",
        alt: "Left bracket",
        className: "knime-hidden xl:block mx-4 h-[207px]"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "knime-hidden md:block xl:max-w-[130px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-sm"
    }, props.block[0].description ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Html, {
        markup: props.block[0].description
    }), /*#__PURE__*/ React.createElement(ArrowLink, {
        text: "Learn more",
        target: props.block[0].target,
        className: "block w-full border-t border-t-gray-400 md:border-0 pt-6 md:pt-0 mt-6 mb-8 md:mb-0 md:mt-1.5"
    })) : null)), /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/Left.svg",
        alt: "Left arrow",
        className: clsx("w-24 md:w-auto absolute -bottom-[53px] md:-bottom-[94px] right-0", {
            "opacity-20": hoveredBlock === 2 || hoveredBlock === 3
        })
    })), /*#__PURE__*/ React.createElement("a", {
        href: props.block[1].target,
        className: "flex flex-1 items-center flex-col-reverse xl:flex-row relative transition-opacity duration-300 group",
        onMouseEnter: function() {
            return handleMouseEnter(2);
        },
        onMouseLeave: handleMouseLeave
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("border bg-yellow-100 border-gray-300 flex-1 max-w-[330px] w-full", {
            "opacity-20": hoveredBlock === 1 || hoveredBlock === 3
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center font-semibold font-heading bg-white py-5 md:py-5 px-4 text-xs md:text-lg lg:text-xl"
    }, props.block[1].title), /*#__PURE__*/ React.createElement("div", {
        className: "p-8 md:px-4 md:py-7 border-t border-t-gray-300 text-center"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/Group2.svg",
        alt: "Business Hub graphic",
        className: "mx-auto"
    }))), /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/Bracket.svg",
        alt: "Left bracket",
        className: "knime-hidden md:block xl:hidden mt-4 mb-7"
    }), /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/right-bracket-graphic.svg",
        alt: "Left bracket",
        className: "knime-hidden xl:block mx-4 h-[207px]"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "knime-hidden md:block xl:max-w-[130px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-sm"
    }, props.block[1].description ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Html, {
        markup: props.block[1].description
    }), /*#__PURE__*/ React.createElement(ArrowLink, {
        text: "Learn more",
        target: props.block[1].target,
        className: "block w-full border-t border-t-gray-400 md:border-0 pt-6 md:pt-0 mt-6 mb-8 md:mb-0 md:mt-1.5"
    })) : null)), /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/Right.svg",
        alt: "Right arrow",
        className: clsx("w-24 md:w-auto absolute -bottom-[53px] md:-bottom-[94px] left-0", {
            "opacity-20": hoveredBlock === 1 || hoveredBlock === 3
        })
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "relative max-w-[688px] mx-auto",
        onMouseEnter: function() {
            return handleMouseEnter(3);
        },
        onMouseLeave: handleMouseLeave
    }, /*#__PURE__*/ React.createElement("a", {
        href: props.block[2].target,
        className: "bg-yellow-100 block p-4 md:py-5 border border-gray-300 text-center"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/KNIME-Logo.svg",
        alt: "KNIME logo",
        className: "mx-auto w-7 md:w-auto mb-2 md:mb-4"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "text-center font-semibold text-xs md:text-lg lg:text-xl"
    }, props.block[2].title)), /*#__PURE__*/ React.createElement("img", {
        src: "/images/software-graphic/bottom-bracket-graphic.svg",
        alt: "Bottom bracket",
        className: clsx("knime-hidden md:block my-4 opacity-0 transition-opacity duration-300", {
            "opacity-100": hoveredBlock
        })
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-10 md:mt-0 md:text-center"
    }, /*#__PURE__*/ React.createElement(LowerBlock, {
        hoveredBlock: hoveredBlock,
        hoveredNumber: 1,
        ctaText: props.block[0].ctaText,
        target: props.block[0].target,
        title: props.block[0].title
    }), /*#__PURE__*/ React.createElement(LowerBlock, {
        hoveredBlock: hoveredBlock,
        hoveredNumber: 2,
        ctaText: props.block[1].ctaText,
        target: props.block[1].target,
        title: props.block[1].title
    }), /*#__PURE__*/ React.createElement(LowerBlock, {
        hoveredBlock: hoveredBlock,
        hoveredNumber: 3,
        ctaText: props.block[2].ctaText,
        target: props.block[2].target,
        title: props.block[2].title
    }))))));
}
function LowerBlock(param) {
    var hoveredBlock = param.hoveredBlock, ctaText = param.ctaText, target = param.target, hoveredNumber = param.hoveredNumber, title = param.title;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("md:opacity-0 transition-opacity duration-300 md:absolute top-[192px] inset-x-0 mx-auto", {
            "!opacity-100": hoveredBlock === hoveredNumber
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block md:hidden text-xl font-medium mb-3"
    }, title), /*#__PURE__*/ React.createElement(Html, {
        markup: ctaText
    }), /*#__PURE__*/ React.createElement(ArrowLink, {
        text: "Learn more",
        target: target,
        className: clsx("block md:justify-center w-full border-t border-t-gray-400 md:border-0 pt-6 md:pt-0 mt-6 mb-8 md:m-0", {
            "md:hidden": hoveredNumber === 1 || hoveredNumber === 2
        })
    }));
}
